import ChantiersController from './chantiers.controller';

export default {
    template: require('./chantiers.tpl.html'),
    controller: ChantiersController
};
